<ng-container *ngIf="isBlocked$ | async">
  <div class="container mb-4">
    <py-notification [type]="'danger'" [message]="'cart.creditLimitExceeded_text' | cxTranslate"></py-notification>
  </div>
</ng-container>
